import type {
  SortableUserColumn,
  UserList,
  UsersListResponse,
  UserSortDirection,
} from '@app/application/user-management/types'

import SFetch from '@app/utils/sfetch'
import { getSignal } from '@app/adapters/abort'
import { USERS_REQUEST_KEY } from '@app/application/user-management/constants'

export const fetchUsers = ({
  list,
  page = 1,
  sortBy,
  sortDirection,
}: {
  list: UserList
  page?: number
  sortBy?: SortableUserColumn
  sortDirection?: UserSortDirection
}): Promise<UsersListResponse | null> => {
  const route =
    list === 'staff'
      ? window.Silverfin.Routes.staff_users_path
      : window.Silverfin.Routes.external_users_path

  return SFetch.json<UsersListResponse>(
    route(window.Silverfin.currentFirmId, {
      format: 'json',
      page,
      sort_by: sortBy,
      sort_direction: sortDirection,
    }),
    { signal: getSignal(USERS_REQUEST_KEY) }
  )
}
